// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Questions_wrap__4xNls","buttons":"Questions_buttons__XJpY2","list":"Questions_list__J0f7U"};